import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoadingShimmerModule } from 'loading-shimmer';

@Component({
  selector: 'app-table-cell-shimmer',
  templateUrl: './table-cell-shimmer.component.html',
  styleUrls: ['./table-cell-shimmer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, LoadingShimmerModule]
})
export class TableCellShimmerComponent {
  @Input() isLoading = false;
  @Input() shimmerWidth?: string;
  @Input() shimmerHeight?: string;
  @Input() shimmerBorderRadius?: string;
}
